<template>
  <div class="step-two-heading">
    <svg width="19" height="24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="a">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.770905 0 0 0 0 0.781719 0 0 0 0 0.806418 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        transform="translate(-225 -8)"
        filter="url(#a)"
        fill="none"
        fill-rule="evenodd"
      >
        <g transform="translate(225 8)" fill="#8BE1FC" fill-rule="nonzero">
          <path
            d="M15.527 21.5l-5.302-2.803L12 15.341l.363-.68c.202-.379.202-.812.036-1.175l2.288-1.396.045-.03.373.443a.756.756 0 001.255-.146 1.06 1.06 0 00.196-1.4l1.245-.762a.362.362 0 00.136-.484.352.352 0 00-.489-.126l-1.305.797-.045.03-3.523-4.198-.776-.983a1.796 1.796 0 00-2.969.217L6.25 9.913a2.04 2.04 0 00.812 2.817l1.34.706 1.457.77-3.77 2.299-4.96-2.62a.768.768 0 10-.716 1.36l4.149 2.192-2.097 1.28-.297-.368a.365.365 0 00-.499-.07.351.351 0 00-.06.504l.247.307-.696.424a.362.362 0 00-.136.483.35.35 0 00.307.177.34.34 0 00.182-.05l.786-.48.323.399a.353.353 0 00.504.045.361.361 0 00.035-.499l-.252-.312 2.374-1.447 9.524 5.035c2.55 1.164 3.216-1.572 3.23-1.643-.599 1.19-2.509.277-2.509.277zm-3.724-8.649l-.68-.363-1.664-.877L11.45 8.16l2.822 3.362-2.328 1.416c-.045-.03-.09-.06-.141-.086zm-4.99 4.042l2.924-1.78-1.376 2.601-1.547-.821z"
          />
          <circle cx="12.574" cy="2.031" r="1.996" />
        </g>
      </g>
    </svg>
    <div style="flex-grow: 1">
      <h4>{{ $t("סוג וכמות נוסעים") }}</h4>
      <ul class="step-two-people">
        <li>
          <b>{{ peopleByAge(18) }}</b> {{ $t("מבוגרים") }}
        </li>
        <li>
          <b>{{ peopleByAge(12) }}</b> {{ $t("ילדים") }}
        </li>
        <li>
          <b>{{ peopleByAge(2) }}</b> {{ $t("תינוקות") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["peopleByAge"],
};
</script>

<style lang="scss" scoped>
.step-two-heading {
  .step-two-people {
    display: flex;
    margin: 0;
    padding: 0;
    margin-top: 5px;

    li {
      font-size: 16.8px;
      letter-spacing: 0;
      margin-left: 20px;
    }
  }
}
</style>